// extracted by mini-css-extract-plugin
module.exports = {"containerWrapper":"View_containerWrapper__8c7RF","contentWithNoHeader":"View_contentWithNoHeader__amnPc"};